import React from "react";
import RightToKnow from "./RightToKnow";
import { Box, tableBodyClasses } from "@mui/material";
import { GlobalTabCollection, StyledTab } from "../../styles.js";

export default function SiteSafety({ setTabValue }) {
  const [tab, setTab] = React.useState(0);
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const renderSearchTab = () => {
    switch (tab) {
      case 0: {
        return <RightToKnow setTabValue={setTabValue} />;
      }

      default: {
        alert(tableBodyClasses);
      }
    }
  };
  return (
    <div>
      <Box sx={{ bgcolor: "#fff" }}>
        <GlobalTabCollection
          value={tab}
          onChange={handleChange}
          aria-label="ant example"
        >
          <StyledTab label="Right To Know" />
        </GlobalTabCollection>
        <Box sx={{ p: 3 }} />
      </Box>
      {renderSearchTab()}
    </div>
  );
}
